import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const RadioLabel = styled.label`
  display: flex;
  height: 30px;
  align-items: center;
  cursor: pointer;
  margin: 15px 0;
  padding-left: 60px;
  color: ${(props) => (props.disabled ? "#a0a0a0" : "#6d6d6d")};
  pointer-events: ${(props) => props.disabled && "none"};
  font-weight: 600;
  position: relative;

  ${mediaMaxWidth.phone`
    padding-left: 40px;
    margin: 10px 0;
    font-size: 0.9em;
  `}
`;

export const Check = styled.div`
  display: block;
  position: absolute;
  border: ${(props) =>
    props.disabled ? "3px solid #a0a0a0" : "3px solid #6d6d6d"};
  border-radius: 100%;
  height: 20px;
  width: 20px;
  left: 0;
  top: 1px;
  transition: border 0.25s linear;

  &:before {
    display: block;
    position: absolute;
    content: "";
    border-radius: 100%;
    height: 14px;
    width: 14px;
    top: 3px;
    left: 3px;
    transition: background-color 0.1s linear;
  }

  ${mediaMaxWidth.phone`
    height: 15px;
    width: 15px;

    &:before {
      height: 11px;
      width: 11px;
      top: 2px;
      left: 2px;
    }
  `}
`;

export const Input = styled.input`
  position: absolute;
  display: flex;
  visibility: hidden;

  &:checked ~ ${Check} {
    border: ${(props) =>
      props.disabled ? "3px solid #a0a0a0" : "3px solid #f2008c"};
  }

  &:checked ~ ${Check}::before {
    background: ${(props) => (props.disabled ? "#a0a0a0" : "#f2008c")};
  }

  &:checked ~ label {
    color: ${(props) => (props.disabled ? "#a0a0a0" : "#f2008c")};
  }
`;
